
import React from "react";
import { Campaign } from "@/types/campaigns";
import { Campaign as LegacyCampaign } from "./CampaignModal";
import CampaignsTable from "./CampaignsTable";

interface CampaignTabContentProps {
  title: string;
  description: string;
  campaigns: Campaign[];
  openEditModal: (campaign: LegacyCampaign) => void;
  openDeleteDialog: (campaign: Campaign) => void;
  openPublishDialog: (campaign: Campaign) => void;
  openResultsSheet: (campaign: LegacyCampaign) => void;
  openViewModal: (campaign: Campaign) => void;
  onDuplicate: (campaign: Campaign) => void;
  onFinalize: (campaign: Campaign) => void;
  onReactivate?: (campaign: Campaign) => void;
  status: "draft" | "active" | "scheduled" | "completed";
}

const CampaignTabContent = ({
  title,
  description,
  campaigns,
  openEditModal,
  openDeleteDialog,
  openPublishDialog,
  openResultsSheet,
  openViewModal,
  onDuplicate,
  onFinalize,
  onReactivate,
  status
}: CampaignTabContentProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        <p className="text-gray-600 mt-1">{description}</p>
      </div>
      
      <CampaignsTable
        campaigns={campaigns}
        openEditModal={openEditModal}
        openDeleteDialog={openDeleteDialog}
        openPublishDialog={openPublishDialog}
        openResultsSheet={openResultsSheet}
        openViewModal={openViewModal}
        onDuplicate={onDuplicate}
        onFinalize={onFinalize}
        onReactivate={onReactivate}
        status={status}
      />
    </div>
  );
};

export default CampaignTabContent;
